module.exports = __webpack_public_path__ + "static/media/february-img.6950ff81.jpg";